import * as React from 'react';
import { useEffect, useRef } from 'react';
import { PageContainer } from '../Components/PageContainer';
import { MapDisplayContext } from '../MapDisplayContext';
import styles from './OpenTableReservation.module.css';
import { useTranslation } from 'react-i18next';
import { useUrlQueryDisplayState } from '../useUrlQueryDisplayState';
import { selectDigitalMap } from 'ducks/universal/digitalMap';
import { useSelector } from 'react-redux';

export const OpenTableReservation = () => {
  const { i18n } = useTranslation();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { activeOpenTableRestaurantId, setActiveOpenTableRestaurantId } = React.useContext(
    MapDisplayContext
  );
  const digitalMap = useSelector(selectDigitalMap);
  const { activePinKey } = useUrlQueryDisplayState();
  const pin = digitalMap?.pins.find((p) => p.key === activePinKey);

  useEffect(() => {
    if (!iframeRef.current) return;

    const iframe = iframeRef.current;
    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) return;

    // Write the HTML content including the script
    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <style>
            .ot-dtp-picker {
              width: calc(100% - 64px) !important;
              margin: 0 16px !important;
              font-family: Inter, sans-serif !important;
              --ot-button-background-color: #3aa0ff !important;
              --ot-button-background-color-active: #0C70CC !important;
            }
          </style>
        </head>
        <body style="margin:0;padding:0;">
          <div id="opentable-widget-container"></div>
          <script 
            type="text/javascript" 
            src="https://www.opentable.com/widget/reservation/loader?rid=${activeOpenTableRestaurantId}&type=standard&lang=${i18n.language}"
          ></script>
        </body>
      </html>
    `);
    doc.close();
  }, [activeOpenTableRestaurantId]);

  return (
    <PageContainer
      onBackClick={() => setActiveOpenTableRestaurantId(null)}
      headerContent={
        <div className={styles['header']}>
          <h1 className={styles['header-title']}>{pin?.title}</h1>
        </div>
      }
    >
      <iframe
        ref={iframeRef}
        className={styles['opentable-widget']}
        title="OpenTable Reservation Widget"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </PageContainer>
  );
};
